import styled from 'styled-components'
import { White } from '../../assets/colors'

export const Container = styled.div`
	background-color: ${White};
	width: 100%;
	border-radius: 12px;
	margin: 10px 0;
	min-height: 100px;
`